import React from 'react';

import { Loading } from 'BridgReusables';

import * as styles from './RouteLoader.scss';

/**
 * Reusable RouteLoader Component
 * @function RouteLoader
 * @param {Object}
 * @return {ReactElement}
 */
const RouteLoader = () => {
  return (
    <div className={styles.loading}>
      <Loading />
    </div>
  );
};

export default RouteLoader;
